import { Header } from "@/components/layout/Header";

interface TestErrorProps {
  error: Error;
}

export const TestError = ({ error }: TestErrorProps) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <div className="flex flex-col items-center justify-center gap-4">
          <p className="text-red-500">Error loading test: {error.message}</p>
        </div>
      </main>
    </div>
  );
};